<template>
  <div class="container">
    <span class="emd-text">{{ $t(value.name) }}</span>

    <EmdSwitcher
      v-model="value.open"
      :id="openName"
      :label="switchLabel"
      :name="openName"
      :disabled="disabled"
      @change="$v.value.open.$touch()"
    />

    <div class="date-period">
      <emd-select
        v-model="value.start"
        :name="startName"
        :disabled="formDisabled"
        @input="handleChange()"
      >
        <option
          v-for="item in options"
          :value="item"
          :key="item + '-start'"
        >
          {{ item }}
        </option>
      </emd-select>
      <span
        :class="{
          to: true,
          disabled: formDisabled
        }"
        >{{ $t('to') }}</span
      >

      <emd-select
        v-model="value.end"
        :name="endName"
        :disabled="formDisabled"
        :class="{
          _state_error: !$v.value.isHoursValid && $v.value.open.checked
        }"
        @input="handleChange()"
      >
        <option
          v-for="item in options"
          :value="item"
          :key="item + '-end'"
        >
          {{ item }}
        </option>
      </emd-select>
    </div>
  </div>
</template>

<script>
import { EmdSwitcher, EmdSelect } from 'emerald-vue/src/components'

import HOURS_ENUM from '@/enums/hours.enum'

const validateHours = value => {
  const { start, end } = value

  const replace = str => Number(str.replace(':', ''))

  const numStart = replace(start)
  const numEnd = replace(end)

  return numEnd > numStart
}

export default {
  name: 'OpenHoursInput',
  components: { EmdSwitcher, EmdSelect },
  props: {
    label: String,
    id: String,
    disabled: Boolean,
    isFirst: Boolean,
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      options: HOURS_ENUM
    }
  },
  validations: {
    value: {
      isHoursValid: validateHours,
      open: {
        checked: value => value
      }
    }
  },
  computed: {
    to () {
      return {
        disabled: !this.value.open
      }
    },
    startName () {
      return `${this.value.name}Start`
    },
    endName () {
      return `${this.value.name}End`
    },
    openName () {
      return `${this.value.name}Open`
    },
    switchLabel () {
      return this.value.open ? this.$t('open') : this.$t('closed')
    },
    formDisabled () {
      return !this.value.open || this.disabled
    }
  },
  methods: {
    handleChange () {
      this.value.valid = !this.$v.value.$invalid
    }
  }
}
</script>

<style scoped>
.container {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr 20px;
}
.date-period {
  display: flex;
  align-items: center;
}
.to {
  margin: 0 16px 0 16px;
}
.disabled {
  color: #454550;
}
</style>

<i18n>
{
  "pt-BR": {
    "monday": "Segunda-Feira",
    "tuesday": "Terça-Feira",
    "wednesday": "Quarta-Feira",
    "thursday": "Quinta-Feira",
    "friday": "Sexta-Feira",
    "saturday": "Sábado",
    "sunday": "Domingo",
    "open": "Aberto",
    "closed": "Fechado",
    "to": "até"
  },
  "en-US": {
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday",
    "open": "Open",
    "closed": "Closed",
    "to": "to"
  }
}
</i18n>
